module.exports = __webpack_public_path__ + "img/刘鹏.1740556e.jpg";